import { motion } from "framer-motion";

const MilkAssociationCaseStudy = () => {
  return (
    <section className="min-h-screen bg-[#050816] text-gray-300 px-6 py-24">
      <div className="max-w-5xl mx-auto">

        {/* Project Title */}
        <motion.div
          initial={{opacity:0, y:40}}
          animate={{opacity:1, y:0}}
          transition={{duration:0.6}}
        >
          <p className="text-purple-400 mb-2">Automation System</p>

          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Milk Association Management System
          </h1>

          <p className="text-gray-400 text-lg max-w-3xl">
            A custom web platform designed to automate vendor reporting,
            asset tracking, and operational workflows for a large milk
            association managing multiple vendors and supervisors.
          </p>
        </motion.div>

        {/* Tech Stack */}
        <div className="flex flex-wrap gap-3 mt-6 mb-12">
          {["React", "Node.js", "MongoDB", "Express", "REST APIs"].map((tech)=>(
            <span
              key={tech}
              className="px-3 py-1 bg-white/5 border border-white/10 rounded-md text-sm"
            >
              {tech}
            </span>
          ))}
        </div>

        {/* Problem */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-white mb-4">Problem</h2>

          <p className="text-gray-400 leading-relaxed">
            The organization was managing milk collection reports, sales
            records, and asset distribution manually using Excel sheets.
            This caused multiple operational issues such as difficulty
            tracking vendor-specific data, managing assets issued across
            multiple levels, and generating accurate reports for
            supervisors and vendors.
          </p>
        </div>

        {/* Solution */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-white mb-4">Solution</h2>

          <p className="text-gray-400 leading-relaxed">
            I developed a centralized web-based management system with
            role-based access for Admin, SubAdmin, Supervisor, and Vendor.
            The platform automates report processing, separates vendor data
            automatically, and provides real-time dashboards for
            operational monitoring.
          </p>
        </div>

        {/* Features */}
        <div className="mb-16">
          <h2 className="text-2xl font-semibold text-white mb-4">
            Key Features
          </h2>

          <ul className="space-y-3 text-gray-400 list-disc ml-5">
            <li>Multi-role authentication system (Admin, SubAdmin, Supervisor, Vendor)</li>
            <li>Excel-based milk and sales report upload with automated data extraction</li>
            <li>Vendor-level data separation using unique vendor IDs</li>
            <li>Asset distribution tracking between Admin → SubAdmin → Vendor</li>
            <li>REST APIs built for integration with vendor and supervisor mobile apps</li>
            <li>Centralized reporting and monitoring dashboard</li>
          </ul>
        </div>

        {/* Results */}
        <div>
          <h2 className="text-2xl font-semibold text-white mb-4">
            Outcome
          </h2>

          <p className="text-gray-400 leading-relaxed">
            The system significantly reduced manual reporting workload and
            improved visibility across the organization. Vendors could
            access their reports directly through the mobile application
            while administrators gained centralized control over
            operational data and asset distribution.
          </p>
        </div>

      </div>
    </section>
  );
};

export default MilkAssociationCaseStudy;